import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css"

const FabricPricePending = props => {
    return (
        <div class="col-md-12 text-center d-flex justify-content-center">
            <div className="col-md-4 p-2" style={{ zIndex: "1000" }}>
                <label>Customer department</label>
                <App
                    customerInfo={props.customerWithDepartment}
                    selectedCustomers={props.storeCustomerData}
                />
            </div>
            <div className="col-md-3">
                <label>Sample Type</label>
                {/* <Field
                    inputType="select"
                    inputName="sampleType"
                    value={props.sampleType}
                    options={props.sampleTypeOptions}
                    onChange={props.updateState}
                    disabled={false}
                    className="Select-control"
                /> */}
                <Picky
                    value={props.arrayValue}
                    options={props.sampleTypeOptions}
                    onChange={props.selectMultipleOption1}
                    open={false}
                    valueKey="value"
                    labelKey="label"
                    multiple={true}
                    includeSelectAll={true}
                    manySelectedPlaceholder={"%s selected"} 
                    allSelectedPlaceholder={"%s selected"}
                    includeFilter={true} 
                    dropdownHeight={300}
                    placeholder="Select a sample type" 
                    disabled={false}
                />
            </div>
            <div className="col-md-2">
                <label>Source of Request</label>
                <Field
                    inputType="select"
                    inputName="typeOfRequest"
                    value={props.typeOfRequest}
                    options={props.typeOfRequestOptions}
                    onChange={props.updateState}
                    disabled={false}
                    className="Select-control"
                />
            </div>

        </div>

    );
};

export default FabricPricePending;


// WEBPACK FOOTER //
// ./src/components/Report/forms/FabricPricePending.js